import React from 'react';
import { motion } from 'framer-motion';
import { Globe2, Scale, Building2 } from 'lucide-react';
import { StaggeredGroup, StaggeredItem } from './Reveal';

const items = [
  { icon: Building2, title: 'Built for import/export teams', desc: 'Purpose-built for customs-facing workflows, not generic document automation.' },
  { icon: Scale, title: 'AI-assisted, rules-driven', desc: 'Deterministic rules catch the issues. AI surfaces the guidance.' },
  { icon: Globe2, title: 'Designed for pre-shipment review', desc: 'Advisory validation before submission, with a clear human-in-the-loop pattern.' },
];

export default function TrustStrip() {
  return (
    <section className="relative border-y border-white/5 py-14">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <StaggeredGroup className="grid grid-cols-1 md:grid-cols-3 gap-10" stagger={0.1}>
          {items.map((it) => (
            <StaggeredItem key={it.title} className="flex gap-4">
              <div data-testid={`trust-${it.title.toLowerCase().replace(/\s+/g, '-')}`} className="flex gap-4">
                <motion.div
                  whileHover={{ rotate: -6, scale: 1.05 }}
                  transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                  className="h-10 w-10 rounded-lg bg-cyan-glow/10 border border-cyan-glow/20 text-cyan-glow grid place-items-center shrink-0"
                >
                  <it.icon className="h-5 w-5" />
                </motion.div>
                <div>
                  <div className="font-display text-white font-semibold">{it.title}</div>
                  <p className="text-sm text-slate-400 mt-1.5 leading-relaxed">{it.desc}</p>
                </div>
              </div>
            </StaggeredItem>
          ))}
        </StaggeredGroup>
      </div>
    </section>
  );
}
